import { unsupportedMark as unsupportedMarkFactory } from '../../next-schema/generated/markTypes';
export const unsupportedMark = unsupportedMarkFactory({
  toDOM() {
    return ['span'];
  }
});